import React from 'react';

import { contentBuilderPropTypes } from '../../utils/propTypes';

import ContentDisplay from './ContentDisplay';
import ContentEditor from './ContentEditor';

const propTypes = contentBuilderPropTypes.content;

const MiroContent = (props) => {

	const {
		data,
		resourceContent,
		isEditing,
		apiIntegrations,
		triggers,
		onUseApiIntegration,
		onCancel,
		onSave,
	} = props;

	const id = data.id;
	const type = data.type;
	const width = data.width;
	const showTitle = data.show_title;

	const initialValues = {
		title: resourceContent?.title,
		data: resourceContent?.data,
		width,
		language: data.language,
		resourceContents: data.resource_contents,
		deletedResourceContents: data.deleted_resource_contents,
	};

	return (
		<div>
			{isEditing &&
				<ContentEditor
					id={id}
					type={type}
					initialValues={initialValues}
					isNew={!data.created_at}
					apiIntegrations={apiIntegrations}
					onUseApiIntegration={onUseApiIntegration}
					onCancel={onCancel}
					onLanguageChange={triggers?.onLanguageChange}
					onSave={onSave}
					onWidthChange={triggers?.onWidthChange} />
			}
			{!isEditing &&
				<ContentDisplay
					id={id}
					data={resourceContent?.data}
					title={resourceContent?.title}
					showTitle={showTitle} />
			}
		</div>
	);

};

MiroContent.propTypes = propTypes;

export default MiroContent;
